import styled from 'styled-components';
import Icon from '@ant-design/icons';
import { Modal as AntdModal, Button as AntButton } from 'antd';

import CloseSvg from 'global/Icons/CloseSvg';

export const Modal = styled(AntdModal)`
  max-width: 400px;
  margin: 0 auto;

  & .ant-modal-wrap {
    z-index: 9999;
  }

  & .ant-modal-header {
    display: none;
  }

  & .ant-modal-content {
    border-radius: 4px;
  }

  & .ant-modal-body {
    padding: 40px 20px 20px;
  }
`;

export const CloseIcon = styled(Icon).attrs({
  component: CloseSvg,
})`
  color: #c1c1c1;
  font-size: 10px;
  transition: 0.3s color linear;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImageWrapper = styled.div`
  img {
    width: 160px;
    height: 120px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const Title = styled.h2`
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  color: #333333;
  margin: 0;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 19px;
  color: #858585;
  margin: 0;
  text-align: center;
  width: 90%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
`;

export const Button = styled(AntButton)`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  font-family: ProximaNovaRg;
  font-size: 13px;
  line-height: 18px;
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
`;
